(() => {
  class FooterDisclosures extends HTMLElement {
    connectedCallback() {
      this.disclosures = [...this.querySelectorAll('details')];
      this.desktopMedia = window.matchMedia('(min-width: 750px)');
      this.handleToggle = this.handleToggle.bind(this);
      this.reconcile = this.reconcile.bind(this);

      this.disclosures.forEach((disclosure) => disclosure.addEventListener('toggle', this.handleToggle));
      this.desktopMedia.addEventListener('change', this.reconcile);
      this.reconcile();
    }

    disconnectedCallback() {
      this.disclosures?.forEach((disclosure) => disclosure.removeEventListener('toggle', this.handleToggle));
      this.desktopMedia?.removeEventListener('change', this.reconcile);
    }

    reconcile() {
      const isDesktop = this.desktopMedia.matches;
      this.disclosures.forEach((disclosure) => {
        const summary = disclosure.querySelector('summary');
        if (!summary) return;

        summary.tabIndex = isDesktop ? -1 : 0;
        summary.inert = isDesktop;
        if (isDesktop) summary.setAttribute('aria-disabled', 'true');
        else summary.removeAttribute('aria-disabled');
        if (isDesktop) disclosure.open = true;
      });
    }

    handleToggle(event) {
      if (this.desktopMedia.matches && !event.currentTarget.open) event.currentTarget.open = true;
    }
  }

  if (!customElements.get('footer-disclosures')) customElements.define('footer-disclosures', FooterDisclosures);
})();
